/** Keep a definite refusal; never encourage a duplicate after an unconfirmed submission. */
export function generationFailureMessage(problem: unknown, submitted: boolean): string {
  const message = problem instanceof Error ? problem.message : 'Could not start the generation.';
  const status = problem && typeof problem === 'object' && 'status' in problem ? Number(problem.status) : 0;
  if (submitted && (!status || status >= 500 || status === 408)) return `${message} The request could not be confirmed. Check My Stuff before starting another generation.`;
  return message;
}
